function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createSelector } from 'reselect';
import { TYPE_EDITING, TYPE_TRANSLATION } from 'researcher/digital-orders/constants';
import featureEnabled from 'shared/helper/feature';
import * as c from './constants';
var initialState = {
  availablePurchases: [],
  companies: [],
  countries: [],
  country: null,
  currencies: [],
  digitalPurchases: [],
  languages: [],
  positions: [],
  institutionTypes: [],
  curie: {
    plan: null,
    loading: false
  },
  status: {
    loaded: false,
    updating: false
  },
  titles: [{
    value: 'Professor',
    label: 'Professor'
  }, {
    value: 'Dr.',
    label: 'Dr.'
  }, {
    value: 'Mr.',
    label: 'Mr.'
  }, {
    value: 'Ms.',
    label: 'Ms.'
  }, {
    value: 'Mrs.',
    label: 'Mrs.'
  }, {
    value: 'Miss',
    label: 'Miss'
  }],
  navigation: {
    changePasswordEnabled: false,
    editSavedAddressesEnabled: false
  },
  digitalPurchasesLoaded: false
};
var getEditSavedAddressesEnabled = function getEditSavedAddressesEnabled(_ref) {
  var application = _ref.application,
    account = _ref.account;
  return account.navigation.editSavedAddressesEnabled && !application.enableAdminOptions;
};
var getChangePasswordEnabled = function getChangePasswordEnabled(_ref2) {
  var account = _ref2.account;
  return account.navigation.changePasswordEnabled;
};
export var getNavigationItems = createSelector(getChangePasswordEnabled, getEditSavedAddressesEnabled, function (_ref3) {
  var location = _ref3.location;
  return location.pathname;
}, function (_ref4) {
  var baseUrl = _ref4.baseUrl;
  return baseUrl;
}, function (_ref5) {
  var application = _ref5.application;
  return application;
}, function (changePasswordEnabled, editSavedAddressesEnabled, url, baseUrl, application) {
  return [{
    name: 'User information',
    url: "".concat(baseUrl)
  }, {
    name: 'Work information',
    url: "".concat(baseUrl, "/work-information")
  }].concat(_toConsumableArray(changePasswordEnabled ? [{
    name: 'Change password',
    url: "".concat(baseUrl, "/password")
  }] : []), _toConsumableArray(editSavedAddressesEnabled ? [{
    name: 'Saved addresses',
    url: "".concat(baseUrl, "/addresses")
  }] : []), _toConsumableArray(!application.enableAdminOptions && featureEnabled('wechat_sso') ? [{
    name: 'Linked accounts',
    url: "".concat(baseUrl, "/linked-accounts")
  }] : [])).map(function (navItem) {
    return _objectSpread(_objectSpread({}, navItem), {}, {
      selected: url.search(navItem.url) !== -1
    });
  });
});
export var getAddress = createSelector(function (_ref6) {
  var match = _ref6.match;
  return match.params.id;
}, function (_ref7) {
  var user = _ref7.user;
  return user.addresses;
}, function (id, addresses) {
  return addresses.find(function (address) {
    return parseInt(address.id, 10) === parseInt(id, 10);
  });
});
export var getDigitalPurchase = createSelector(function (_ref8) {
  var match = _ref8.match;
  return match.params.identity;
}, function (_ref9) {
  var account = _ref9.account;
  return account.digitalPurchases;
}, function (identity, digitalPurchases) {
  return digitalPurchases.find(function (digitalPurchase) {
    return identity === digitalPurchase.identity;
  }) || {};
});
var getPurchaseType = createSelector(function (_ref10) {
  var match = _ref10.match;
  return match.params.type;
}, getDigitalPurchase, function (type, digitalPurchase) {
  return digitalPurchase.type || type;
});
export var getAvailableDigitalPurchases = createSelector(getPurchaseType, function (_ref11) {
  var account = _ref11.account;
  return account.availablePurchases;
}, function (type, availablePurchases) {
  return availablePurchases.filter(function (availablePurchase) {
    return availablePurchase.type === type;
  }).map(function (availablePurchase) {
    return _objectSpread(_objectSpread({}, availablePurchase), {}, {
      label: availablePurchase.name,
      value: availablePurchase.identity
    });
  });
});
export var getDigitalEditingPurchases = createSelector(function (_ref12) {
  var account = _ref12.account;
  return account.digitalPurchases;
}, function (digitalPurchases) {
  return digitalPurchases.filter(function (digitalPurchase) {
    return digitalPurchase.type === TYPE_EDITING;
  }).map(function (digitalPurchase) {
    return _objectSpread(_objectSpread({}, digitalPurchase), {}, {
      status: digitalPurchase.valid ? 'Active' : 'Expired',
      statusClass: digitalPurchase.valid ? 'success' : 'danger'
    });
  });
});
export var getPaddleSubscription = createSelector(function (_ref13) {
  var account = _ref13.account;
  return account.digitalPurchases;
}, function (digitalPurchases) {
  var _digitalPurchases$fil;
  return (_digitalPurchases$fil = digitalPurchases.filter(function (digitalPurchase) {
    return digitalPurchase.valid;
  })[0]) === null || _digitalPurchases$fil === void 0 ? void 0 : _digitalPurchases$fil.paddleSubscription;
});
export var getDigitalTranslationPurchases = createSelector(function (_ref14) {
  var account = _ref14.account;
  return account.digitalPurchases;
}, function (digitalPurchases) {
  return digitalPurchases.filter(function (digitalPurchase) {
    return digitalPurchase.type === TYPE_TRANSLATION;
  }).map(function (digitalPurchase) {
    var status = 'Expired';
    var statusClass = 'danger';
    if (digitalPurchase.numberOfUsesRemaining === 0) {
      status = 'Used';
      statusClass = 'info';
    } else if (digitalPurchase.valid) {
      status = 'Active';
      statusClass = 'success';
    }
    return _objectSpread(_objectSpread({}, digitalPurchase), {}, {
      status: status,
      statusClass: statusClass
    });
  });
});
export var getIsAdmin = createSelector(function (_ref15) {
  var application = _ref15.application;
  return application.enableAdminOptions;
}, function (_ref16) {
  var user = _ref16.user;
  return user;
}, function (enableAdminOptions, user) {
  return enableAdminOptions || user && user.impersonatorIdentity;
});
export var getDisplayCurrentPassword = createSelector(getIsAdmin, function (_ref17) {
  var user = _ref17.user;
  return user;
}, function (isAdmin, user) {
  return !isAdmin && user.hasLocalIdentity;
});
export var getApiRoot = createSelector(getIsAdmin, function (isAdmin) {
  return isAdmin ? '/api/admin/auth' : '/api/auth';
});
export var getChinaLocalization = createSelector(function (_ref18) {
  var application = _ref18.application;
  return application.currentLocalization;
}, function (currentLocalization) {
  return (currentLocalization === null || currentLocalization === void 0 ? void 0 : currentLocalization.identity) === 'aje-china';
});
export var getProfileFormFields = createSelector(function (_ref19) {
  var application = _ref19.application;
  return application.enableAdminOptions;
}, function (enableAdminOptions) {
  return {
    additionalContactInformation: true,
    admin: enableAdminOptions,
    emailConfirmation: false,
    foundUs: true,
    instititutionInformation: false,
    localizationPreferencesFields: {
      country: true,
      currency: true,
      language: true
    },
    marketingOptIn: false,
    orcid: true,
    submit: {
      text: 'Save Changes',
      alignment: 'left'
    },
    title: true,
    tosSelectionRequired: false
  };
});
export var getRegisterFormFields = createSelector(function (_ref20) {
  var application = _ref20.application;
  return application.enableAdminOptions;
}, function (enableAdminOptions) {
  if (featureEnabled('simplified_registration')) {
    return {
      additionalContactInformation: false,
      admin: enableAdminOptions,
      emailConfirmation: false,
      foundUs: false,
      instititutionInformation: false,
      localizationPreferencesFields: {
        country: true,
        currency: false,
        language: false
      },
      marketingOptIn: true,
      orcid: false,
      submit: {
        text: 'Sign up',
        alignment: 'right'
      },
      title: false,
      tosSelectionRequired: true
    };
  }
  return {
    additionalContactInformation: false,
    admin: enableAdminOptions,
    emailConfirmation: true,
    foundUs: true,
    instititutionInformation: true,
    localizationPreferencesFields: {
      country: true,
      currency: true,
      language: true
    },
    marketingOptIn: true,
    orcid: true,
    submit: {
      text: 'Sign up',
      alignment: 'right'
    },
    title: false,
    tosSelectionRequired: true
  };
});
var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.ACCOUNT_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loaded: true
      });
    case c.QR_CODE_REQUESTED:
    case c.UPDATE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        updating: true
      });
    case c.QR_CODE_RETRIEVED:
    case c.UPDATE_REQUEST_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        updating: false
      });
    default:
      return state;
  }
};
var digitalPurchases = function digitalPurchases() {
  var digitalPurchases = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.digitalPurchases;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.DIGITAL_PURCHASE_CREATED:
      digitalPurchases.push(_objectSpread(_objectSpread({}, action.digitalPurchase), {}, {
        numberOfUsesRemaining: action.digitalPurchase.numberOfUsesAvailable
      }));
      return _toConsumableArray(digitalPurchases);
    case c.DIGITAL_PURCHASE_DELETED:
      return digitalPurchases.filter(function (digitalPurchase) {
        return digitalPurchase.identity !== action.identity;
      });
    case c.DIGITAL_PURCHASE_UPDATED:
      return digitalPurchases.map(function (digitalPurchase) {
        if (digitalPurchase.identity === action.digitalPurchase.identity) {
          return _objectSpread(_objectSpread({}, action.digitalPurchase), {}, {
            numberOfUsesRemaining: action.digitalPurchase.numberOfUsesAvailable - (digitalPurchase.numberOfUsesAvailable - digitalPurchase.numberOfUsesRemaining)
          });
        }
        return digitalPurchase;
      });
    default:
      return digitalPurchases;
  }
};
export var mapCuriePlan = function mapCuriePlan(plan) {
  var _plan$paddleSubscript, _plan$paddleSubscript2, _plan$paddleSubscript3;
  return {
    grantingMechanism: plan.grantingMechanism,
    billingInterval: plan.paddleSubscription ? plan.subscriptionInterval : null,
    endDate: (_plan$paddleSubscript = (_plan$paddleSubscript2 = plan.paddleSubscription) === null || _plan$paddleSubscript2 === void 0 ? void 0 : _plan$paddleSubscript2.validThrough) !== null && _plan$paddleSubscript !== void 0 ? _plan$paddleSubscript : plan.endsAt,
    preferredGroupCode: plan.preferredGroupCode,
    startDate: plan.startsAt,
    receiptCode: plan.receiptCode,
    planStatus: plan.status,
    planType: plan.planType,
    editsUsed: plan.editsUsed,
    translationsUsed: plan.hasTranslation && (plan.status === 'active' || plan.status === 'cancelled') ? plan.translationsUsed : 'Not available',
    planPrice: plan.planPrice,
    paddleId: (_plan$paddleSubscript3 = plan.paddleSubscription) === null || _plan$paddleSubscript3 === void 0 ? void 0 : _plan$paddleSubscript3.paddleId,
    preprintsUserIdentity: plan.preprintsUserIdentity
  };
};
export var curie = function curie() {
  var curie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.curie;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.RUBRIQ_PLAN_REQUESTED:
      return {
        plan: null,
        loading: true
      };
    case c.RUBRIQ_PLAN_LOADED:
      return {
        plan: action.json ? mapCuriePlan(action.json) : null,
        loading: false
      };
    case c.RUBRIQ_PLAN_EXPIRATION_UPDATED:
      return _objectSpread(_objectSpread({}, curie), {}, {
        plan: _objectSpread(_objectSpread({}, curie.plan), {}, {
          endDate: action.newExpirationDate
        })
      });
    default:
      return curie;
  }
};
export var accountReducer = function accountReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.ACCOUNT_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        companies: action.companies,
        countries: action.countries,
        country: action.country,
        currencies: action.currencies,
        institutionTypes: action.institutionTypes,
        languages: action.languages,
        navigation: action.navigation,
        positions: action.positions,
        status: status(state.status, action)
      });
    case c.QR_CODE_RETRIEVED:
    case c.QR_CODE_REQUESTED:
    case c.UPDATE_REQUESTED:
    case c.UPDATE_REQUEST_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action)
      });
    case c.DIGITAL_PURCHASE_CREATED:
    case c.DIGITAL_PURCHASE_DELETED:
    case c.DIGITAL_PURCHASE_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        digitalPurchases: digitalPurchases(state.digitalPurchases, action)
      });
    case c.DIGITAL_PURCHASES_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        availablePurchases: action.availablePurchases,
        digitalPurchases: action.digitalPurchases,
        digitalPurchasesLoaded: true
      });
    case c.RUBRIQ_PLAN_LOADED:
    case c.RUBRIQ_PLAN_REQUESTED:
    case c.RUBRIQ_PLAN_EXPIRATION_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        curie: curie(state.curie, action)
      });
    default:
      return state;
  }
};